import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { useViewProvider } from '../contexts/view-provider-context/ViewProvider';

const StyledLoader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export function Loader(): ReactElement {
  const viewProvider = useViewProvider();

  return <StyledLoader>{viewProvider.renderLoader()}</StyledLoader>;
}
